import { Spinner } from "../Spinner";
/** How much of the filtered list is loaded, beside its next-page action. */
export function ListPagination({ shown, total, hasMore, busy, onMore }: { shown: number; total: number; hasMore: boolean; busy: boolean; onMore: () => void }) {
  if (!shown) return null;
  return <div className="bw-list-pagination">
    {hasMore && <button type="button" className="bw-btn bw-btn--quiet bw-list-more" disabled={busy} aria-busy={busy} onClick={onMore}>{busy && <Spinner />}Show more</button>}
    <span className="bw-area-hint" role="status">Showing {shown} of {total}</span>
  </div>;
}
